import * as React from "react";
import { AlertTriangle } from "lucide-react";
import { cn } from "@/lib/utils";

interface MissingValueWarningProps {
  message: string;
  className?: string;
}

export const MissingValueWarning: React.FC<MissingValueWarningProps> = ({ message, className }) => (
  <div
    className={cn(
      "flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 text-sm text-amber-800",
      className
    )}
  >
    <AlertTriangle className="size-4 mt-0.5 shrink-0" />
    <span>{message}</span>
  </div>
);
